import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_2 = {
  class: "W-100 D-Flex FlexWrap P-Rel",
  style: {"z-index":"500","gap":"1em"}
}
const _hoisted_3 = { class: "F-Bold M-Auto" }
const _hoisted_4 = { class: "F-Bold M-Auto" }
const _hoisted_5 = {
  id: "TableToPrint",
  class: "ReportTableContainer W-100",
  style: {}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesSearchInput = _resolveComponent("CookiesSearchInput")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printIT())),
        class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT M-Auto",
        style: {"height":"2em"}
      }, [
        _createVNode(_component_CookiesIcon, {
          class: "V-Auto",
          style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
          ID: 'Printer'
        }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Translate('Print')), 1)
      ]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DownloadExcel())),
        class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT M-Auto",
        style: {"height":"2em","width":"7em"}
      }, [
        _createVNode(_component_CookiesIcon, {
          class: "V-Auto",
          style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
          ID: 'Reports'
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Translate('Download')), 1)
      ]),
      _createVNode(_component_CookiesSearchInput, {
        Res: 'R_Items_Search',
        Placeholder: _ctx.Translate('Search...')
      }, null, 8, ["Placeholder"]),
      _createVNode(_component_CookiesDropInputObject, {
        Name: _ctx.Translate('Category'),
        Default: '',
        Options: _ctx.Categories,
        Selectors: ['Name'],
        Res: 'R_Items_Category'
      }, null, 8, ["Name", "Options"]),
      _createVNode(_component_CookiesDropInputObject, {
        Name: _ctx.Translate('Brand'),
        Default: '',
        Options: _ctx.Brands,
        Selectors: ['Name'],
        Res: 'R_Items_Brand'
      }, null, 8, ["Name", "Options"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CookiesTable, {
        class: "W-100",
        Loading: _ctx.Loading.length > 0,
        CookiesData: _ctx.FilteredData,
        TableSettings: _ctx.TableSettings
      }, null, 8, ["Loading", "CookiesData", "TableSettings"])
    ])
  ], 64))
}